import React, { Component } from 'react'
import classnames from 'classnames'
//
import _ from './utils'
import Lifecycle from './lifecycle'
import Methods from './methods'
import defaultProps from './defaultProps'
import propTypes from './propTypes'
import './index.css';
import Checkbox from '../../../../../common/Checkbox/'
export const ReactTableDefaults = defaultProps

export default class ReactTable extends Methods(Lifecycle(Component)) {
  static propTypes = propTypes
  static defaultProps = defaultProps

  constructor(props) {
    super()

    this.getResolvedState = this.getResolvedState.bind(this)
    this.getDataModel = this.getDataModel.bind(this)
    this.getSortedData = this.getSortedData.bind(this)
    this.fireFetchData = this.fireFetchData.bind(this)
    this.getPropOrState = this.getPropOrState.bind(this)
    this.getStateOrProp = this.getStateOrProp.bind(this)
    this.filterData = this.filterData.bind(this)
    this.sortData = this.sortData.bind(this)
    this.getMinRows = this.getMinRows.bind(this)
    this.onPageChange = this.onPageChange.bind(this)
    this.onPageSizeChange = this.onPageSizeChange.bind(this)
    this.sortColumn = this.sortColumn.bind(this)
    this.filterColumn = this.filterColumn.bind(this)
    this.resizeColumnStart = this.resizeColumnStart.bind(this)
    this.resizeColumnEnd = this.resizeColumnEnd.bind(this)
    this.resizeColumnMoving = this.resizeColumnMoving.bind(this)
    this.expandableHander = this.expandableHander.bind(this);
    this.expandableHanderOnEnter = this.expandableHanderOnEnter.bind(this);
    this.selectedGroup = this.selectedGroup.bind(this);
    this.checkedValues = [];

    this.state = {
      page: 0,
      pageSize: props.defaultPageSize,
      sorted: props.defaultSorted,
      expanded: props.defaultExpanded,
      filtered: props.defaultFiltered,
      resized: props.defaultResized,
      currentlyResizing: false,
      skipNextSort: false,
      isCaseList: props.isCaseList ? true : false,
      selectedCheck: []
    }

  }

  expandableHander(index, event) {
    let contactStr = `rowId_${index}`;
    let docObj = this[contactStr].parentNode;
    let objectClass = document.getElementsByClassName("expandable");
    //let objectClass = ReactDOM.findDOMNode(this.getElementsByClassName('expandable'));
    if (docObj.style.display === "none") {
      for (var i = 0; i < objectClass.length; i++) {
        objectClass[i].parentNode.classList.remove("active");
        objectClass[i].previousSibling.childNodes[0].childNodes[0].classList.remove("icon-chevron-up");
        objectClass[i].style.display = "none";
      }
      docObj.style.display = "block";
      docObj.parentNode.classList.add("active");
      docObj.previousSibling.childNodes[0].childNodes[0].classList.add("icon-chevron-up");
    } else {
      docObj.style.display = "none";
      docObj.parentNode.classList.remove("active");
      docObj.previousSibling.childNodes[0].childNodes[0].classList.remove("icon-chevron-up");
    }

  }

  expandableHanderOnEnter(index, event) {
    if (event.keyCode === 13) {
      let contactStr = `rowId_${index}`;
      let docObj = this[contactStr].parentNode;
      let objectClass = document.getElementsByClassName("expandable");
      //let objectClass = ReactDOM.findDOMNode(this.getElementsByClassName('expandable'));
      if (docObj.style.display === "none") {
        for (var i = 0; i < objectClass.length; i++) {
          objectClass[i].parentNode.classList.remove("active");
          objectClass[i].previousSibling.childNodes[0].childNodes[0].classList.remove("icon-chevron-up");
          objectClass[i].style.display = "none";
        }
        docObj.style.display = "block";
        docObj.parentNode.classList.add("active");
        docObj.previousSibling.childNodes[0].childNodes[0].classList.add("icon-chevron-up");
      } else {
        docObj.style.display = "none";
        docObj.parentNode.classList.remove("active");
        docObj.previousSibling.childNodes[0].childNodes[0].classList.remove("icon-chevron-up");
      }
    }
  }

  expandableHanderFun() {
    let objectClass = document.getElementsByClassName("expandable");
    for (var i = 0; i < objectClass.length; i++) {
      objectClass[i].parentNode.classList.remove("active");
      objectClass[i].previousSibling.childNodes[0].childNodes[0].classList.remove("icon-chevron-up");
      objectClass[i].style.display = "none";
    }
  }
  rowLink(rowInfo) {
    if (this.props.rowLink) {
      this.props.rowLink(rowInfo);
    }
  }

  userLink(rowInfo) {
    if (this.props.noLink) {
      this.props.noLink(rowInfo);
    }
  }

  checkGroup(rowInfo) {
    if (this.props.checkGroup) {
      this.props.checkGroup(rowInfo);
    }
  }

  selectedGroup = (event, rowInfo) => {
    if (event.target.checked) {
      this.checkedValues.push(rowInfo.id);
    } else {
      this.checkedValues.remove(rowInfo.id);
    }
    this.props.selectedGroup(event, this.checkedValues)
  }

  isChecked = (id) => {
    return this.checkedValues.indexOf(id) !== -1;
  }

  render() {
    const resolvedState = this.getResolvedState()

    const {
      children,
      className,
      style,
      getProps,
      getTableProps,
      getTheadGroupProps,
      getTheadGroupTrProps,
      getTheadGroupThProps,
      getTheadProps,
      getTheadTrProps,
      getTheadThProps,
      getTheadFilterProps,
      getTheadFilterTrProps,
      getTheadFilterThProps,
      getTbodyProps,
      getTrGroupProps,
      getTrProps,
      getTdProps,
      getTfootProps,
      getTfootTrProps,
      getTfootTdProps,
      getPaginationProps,
      getLoadingProps,
      getNoDataProps,
      getResizerProps,
      showPagination,
      showPaginationTop,
      showPaginationBottom,
      manual,
      loadingText,
      noDataText,
      sortable,
      resizable,
      filterable,
      pivotIDKey,
      pivotValKey,
      pivotBy,
      subRowsKey,
      aggregatedKey,
      originalKey,
      indexKey,
      groupedByPivotKey,
      loading,
      pageSize,
      page,
      sorted,
      filtered,
      resized,
      expanded,
      pages,
      onExpandedChange,
      TableComponent,
      TheadComponent,
      TbodyComponent,
      TrGroupComponent,
      TrComponent,
      ThComponent,
      TdComponent,
      TfootComponent,
      PaginationComponent,
      LoadingComponent,
      SubComponent,
      NoDataComponent,
      ResizerComponent,
      ExpanderComponent,
      PivotValueComponent,
      PivotComponent,
      AggregatedComponent,
      FilterComponent,
      resolvedData,
      allVisibleColumns,
      headerGroups,
      hasHeaderGroups,
      sortedData,
      currentlyResizing,
    } = resolvedState

    // Pagination
    const startRow = pageSize * page
    const endRow = startRow + pageSize
    let pageRows = manual ? resolvedData : sortedData.slice(startRow, endRow)
    const minRows = this.getMinRows()
    const padRows = _.range(Math.max(minRows - pageRows.length, 0))

    const hasColumnFooter = allVisibleColumns.some(d => d.Footer)
    const hasFilters = filterable || allVisibleColumns.some(d => d.filterable)

    const recurseRowsViewIndex = (rows, path = [], index = -1) => {
      return [
        rows.map((row, i) => {
          index++
          const rowWithViewIndex = {
            ...row,
            _viewIndex: index,
          }
          const newPath = path.concat([i])
          if (rowWithViewIndex[subRowsKey] && _.get(expanded, newPath)) {
            ;[rowWithViewIndex[subRowsKey], index] = recurseRowsViewIndex(
              rowWithViewIndex[subRowsKey],
              newPath,
              index
            )
          }
          return rowWithViewIndex
        }),
        index,
      ]
    }
      ;[pageRows] = recurseRowsViewIndex(pageRows)

    const canPrevious = page > 0
    const canNext = page + 1 < pages

    const rowMinWidth = _.sum(
      allVisibleColumns.map(d => {
        const resizedColumn = resized.find(x => x.id === d.id) || {}
        return _.getFirstDefined(resizedColumn.value, d.width, d.minWidth)
      })
    )

    let rowIndex = -1

    const finalState = {
      ...resolvedState,
      startRow,
      endRow,
      pageRows,
      minRows,
      padRows,
      hasColumnFooter,
      canPrevious,
      canNext,
      rowMinWidth,
    }

    // Visual Components

    const makeHeaderGroups = () => {
      const theadGroupProps = _.splitProps(
        getTheadGroupProps(finalState, undefined, undefined, this)
      )
      const theadGroupTrProps = _.splitProps(
        getTheadGroupTrProps(finalState, undefined, undefined, this)
      )
      return (
        <TheadComponent
          className={classnames('-headerGroups', theadGroupProps.className)}
          style={{
            ...theadGroupProps.style,
            minWidth: `${rowMinWidth}px`,
          }}
          {...theadGroupProps.rest}
        >
          <TrComponent
            className={theadGroupTrProps.className}
            style={theadGroupTrProps.style}
            {...theadGroupTrProps.rest}
          >
            {headerGroups.map(makeHeaderGroup)}
          </TrComponent>
        </TheadComponent>
      )
    }

    const makeHeaderGroup = (column, i) => {
      const resizedValue = col =>
        (resized.find(x => x.id === col.id) || {}).value
      const flex = _.sum(
        column.columns.map(
          col => (col.width || resizedValue(col) ? 0 : col.minWidth)
        )
      )
      const width = _.sum(
        column.columns.map(col =>
          _.getFirstDefined(resizedValue(col), col.width, col.minWidth)
        )
      )
      const maxWidth = _.sum(
        column.columns.map(col =>
          _.getFirstDefined(resizedValue(col), col.width, col.maxWidth)
        )
      )

      const theadGroupThProps = _.splitProps(
        getTheadGroupThProps(finalState, undefined, column, this)
      )
      const columnHeaderProps = _.splitProps(
        column.getHeaderProps(finalState, undefined, column, this)
      )

      const classes = [
        column.headerClassName,
        theadGroupThProps.className,
        columnHeaderProps.className,
      ]

      const styles = {
        ...column.headerStyle,
        ...theadGroupThProps.style,
        ...columnHeaderProps.style,
      }

      const rest = {
        ...theadGroupThProps.rest,
        ...columnHeaderProps.rest,
      }

      const flexStyles = {
        flex: `${flex} 0 auto`,
        width: _.asPx(width),
        maxWidth: _.asPx(maxWidth),
      }

      return (
        <ThComponent
          key={i + '-' + column.id}
          className={classnames(classes)}
          style={{
            ...styles,
            ...flexStyles,
          }}
          {...rest}
        >
          {_.normalizeComponent(column.Header, {
            data: sortedData,
            column: column,
          })}
        </ThComponent>
      )
    }

    const makeHeaders = () => {
      const theadProps = _.splitProps(
        getTheadProps(finalState, undefined, undefined, this)
      )
      const theadTrProps = _.splitProps(
        getTheadTrProps(finalState, undefined, undefined, this)
      )
      return (
        <TheadComponent
          className={classnames('-header', theadProps.className)}
          style={{
            ...theadProps.style,
            minWidth: `${rowMinWidth}px`,
          }}
          {...theadProps.rest}
        >
          <TrComponent
            className={theadTrProps.className}
            style={theadTrProps.style}
            {...theadTrProps.rest}
          >
            {allVisibleColumns.map(makeHeader)}
          </TrComponent>
        </TheadComponent>
      )
    }

    const makeHeader = (column, i) => {
      const resizedCol = resized.find(x => x.id === column.id) || {}
      const sort = sorted.find(d => d.id === column.id)
      const show =
        typeof column.show === 'function' ? column.show() : column.show
      const width = _.getFirstDefined(
        resizedCol.value,
        column.width,
        column.minWidth
      )
      const maxWidth = _.getFirstDefined(
        resizedCol.value,
        column.width,
        column.maxWidth
      )
      const theadThProps = _.splitProps(
        getTheadThProps(finalState, undefined, column, this)
      )
      const columnHeaderProps = _.splitProps(
        column.getHeaderProps(finalState, undefined, column, this)
      )

      const classes = [
        column.headerClassName,
        theadThProps.className,
        columnHeaderProps.className,
      ]

      const styles = {
        ...column.headerStyle,
        ...theadThProps.style,
        ...columnHeaderProps.style,
      }

      const rest = {
        ...theadThProps.rest,
        ...columnHeaderProps.rest,
      }

      const isResizable = _.getFirstDefined(column.resizable, resizable, false)
      const resizer = isResizable
        ? (<ResizerComponent
          onMouseDown={e => this.resizeColumnStart(e, column, false)}
          onTouchStart={e => this.resizeColumnStart(e, column, true)}
          {...resizerProps}
        />)
        : null

      const isSortable = _.getFirstDefined(column.sortable, sortable, false)
      let tabIndexRowHeader = {};
      if (column.Header !== '') {
        tabIndexRowHeader = {
          tabIndex: 0
        }
      }


      return (
        <ThComponent
          key={i + '-' + column.id}
          className={classnames(
            classes,
            isResizable && 'rt-resizable-header',
            this.props.isCheckbox && column.id === 'checkbox' && 'rt-checkbox',
            sort ? (sort.desc ? '-sort-desc' : '-sort-asc') : '',
            isSortable && '-cursor-pointer',
            !show && '-hidden',
            pivotBy &&
            pivotBy.slice(0, -1).includes(column.id) &&
            'rt-header-pivot'
          )}
          style={{
            ...styles,
            flex: `${width} 0 auto`,
            width: _.asPx(width),
            maxWidth: _.asPx(maxWidth),
          }}
          toggleSort={e => {
            this.expandableHanderFun();
            isSortable && this.sortColumn(column, e.shiftKey)
          }}
          {...tabIndexRowHeader}
          {...rest}
        >
          <div className={classnames(isResizable && 'rt-resizable-header-content')} >
            {_.normalizeComponent(column.Header, {
              data: sortedData,
              column: column,
            })}
            {
              column.sortable === false ? '' : <i className={sort ? (sort.desc ? 'icon icon-stock-up sortIcon' : 'icon icon-stock-down sortIcon') : 'icon icon-stock-down sortIcon'}></i>
            }
          </div>

          {resizer}

        </ThComponent>
      )
    }

    const makeFilters = () => {
      const theadFilterProps = _.splitProps(
        getTheadFilterProps(finalState, undefined, undefined, this)
      )
      const theadFilterTrProps = _.splitProps(
        getTheadFilterTrProps(finalState, undefined, undefined, this)
      )
      return (
        <TheadComponent
          className={classnames('-filters', theadFilterProps.className)}
          style={{
            ...theadFilterProps.style,
            minWidth: `${rowMinWidth}px`,
          }}
          {...theadFilterProps.rest}
        >
          <TrComponent
            className={theadFilterTrProps.className}
            style={theadFilterTrProps.style}
            {...theadFilterTrProps.rest}
          >
            {allVisibleColumns.map(makeFilter)}
          </TrComponent>
        </TheadComponent>
      )
    }

    const makeFilter = (column, i) => {
      const resizedCol = resized.find(x => x.id === column.id) || {}
      const width = _.getFirstDefined(
        resizedCol.value,
        column.width,
        column.minWidth
      )
      const maxWidth = _.getFirstDefined(
        resizedCol.value,
        column.width,
        column.maxWidth
      )
      const theadFilterThProps = _.splitProps(
        getTheadFilterThProps(finalState, undefined, column, this)
      )
      const columnHeaderProps = _.splitProps(
        column.getHeaderProps(finalState, undefined, column, this)
      )

      const classes = [
        column.headerClassName,
        theadFilterThProps.className,
        columnHeaderProps.className,
      ]

      const styles = {
        ...column.headerStyle,
        ...theadFilterThProps.style,
        ...columnHeaderProps.style,
      }

      const rest = {
        ...theadFilterThProps.rest,
        ...columnHeaderProps.rest,
      }

      const filter = filtered.find(filter => filter.id === column.id)

      const ResolvedFilterComponent = column.Filter || FilterComponent

      const isFilterable = _.getFirstDefined(
        column.filterable,
        filterable,
        false
      )

      return (
        <ThComponent
          key={i + '-' + column.id}
          className={classnames(classes)}
          style={{
            ...styles,
            flex: `${width} 0 auto`,
            width: _.asPx(width),
            maxWidth: _.asPx(maxWidth),
          }}
          {...rest}
        >
          {isFilterable
            ? _.normalizeComponent(
              ResolvedFilterComponent,
              {
                column,
                filter,
                onChange: value => this.filterColumn(column, value),
              },
              defaultProps.column.Filter
            )
            : null}
        </ThComponent>
      )
    }

    const makePageRow = (row, i, path = []) => {
      const rowInfo = {
        original: row[originalKey],
        row: row,
        index: row[indexKey],
        viewIndex: ++rowIndex,
        pageSize: pageSize,
        page: page,
        level: path.length,
        nestingPath: path.concat([i]),
        aggregated: row[aggregatedKey],
        groupedByPivot: row[groupedByPivotKey],
        subRows: row[subRowsKey]
      }

      const isExpanded = _.get(expanded, rowInfo.nestingPath)

      const trGroupProps = getTrGroupProps(finalState, rowInfo, undefined, this)
      const trProps = _.splitProps(
        getTrProps(finalState, rowInfo, undefined, this)
      )

      let TdRow = "";
      //let iconClassStatus =""
      // if(this.props.dummyRole){
      //    iconClassStatus = this.props.dummyRole(rowInfo.row.status) === true ? "icon icon-circle-error-solid gdoc-tab-tabwarninglist" : "";
      // }


      return (
        <TrGroupComponent key={rowInfo.nestingPath.join('_')} {...trGroupProps} >
          <TrComponent
            className={classnames(
              trProps.className,
              row._viewIndex % 2 ? '-even' : '-odd'
            )}
            style={trProps.style}
            {...trProps.rest}


          >
            {
              allVisibleColumns.map((column, i2) => {

                const resizedCol = resized.find(x => x.id === column.id) || {}
                const show =
                  typeof column.show === 'function' ? column.show() : column.show
                const width = _.getFirstDefined(
                  resizedCol.value,
                  column.width,
                  column.minWidth
                )
                const maxWidth = _.getFirstDefined(
                  resizedCol.value,
                  column.width,
                  column.maxWidth
                )
                const tdProps = _.splitProps(
                  getTdProps(finalState, rowInfo, column, this)
                )
                const columnProps = _.splitProps(
                  column.getProps(finalState, rowInfo, column, this)
                )

                const classes = [
                  tdProps.className,
                  column.className,
                  columnProps.className,
                ]

                const styles = {
                  ...tdProps.style,
                  ...column.style,
                  ...columnProps.style,
                }

                const cellInfo = {
                  ...rowInfo,
                  isExpanded,
                  column: { ...column },
                  value: rowInfo.row[column.id],
                  pivoted: column.pivoted,
                  expander: column.expander,
                  resized,
                  show,
                  width,
                  maxWidth,
                  tdProps,
                  columnProps,
                  classes,
                  styles,
                }

                const value = cellInfo.value

                let useOnExpanderClick
                let isBranch
                let isPreview

                const onExpanderClick = e => {
                  let newExpanded = _.clone(expanded)
                  if (isExpanded) {
                    newExpanded = _.set(newExpanded, cellInfo.nestingPath, false)
                  } else {
                    newExpanded = _.set(newExpanded, cellInfo.nestingPath, {})
                  }

                  return this.setStateWithData(
                    {
                      expanded: newExpanded,
                    },
                    () => {
                      onExpandedChange &&
                        onExpandedChange(newExpanded, cellInfo.nestingPath, e)
                    }
                  )
                }

                // Default to a standard cell
                let resolvedCell = _.normalizeComponent(
                  column.Cell,
                  cellInfo,
                  value
                )

                let resolvedCellRelated = [];

                cellInfo.row._original.associations !== undefined && cellInfo.row._original.associations.length > 0 && cellInfo.row._original.associations.map((item, key) => {
                  resolvedCellRelated.push(<span key={item.id || key}>{item.name}</span>)
                });

                let resolvedProductCount = 0;

                if (cellInfo.row._original.productDatas !== undefined) {
                  resolvedProductCount = cellInfo.row._original.productDatas.length
                }

                if (typeof resolvedCell === 'object') {
                  resolvedCell = resolvedCell.name
                }

                //cellInfo.row._original.related[column.id]
                // Resolve Renderers
                const ResolvedAggregatedComponent =
                  column.Aggregated ||
                  (!column.aggregate ? AggregatedComponent : column.Cell)
                const ResolvedExpanderComponent =
                  column.Expander || ExpanderComponent
                const ResolvedPivotValueComponent =
                  column.PivotValue || PivotValueComponent
                const DefaultResolvedPivotComponent =
                  PivotComponent ||
                  (props => (
                    <div>
                      <ResolvedExpanderComponent {...props} />
                      <ResolvedPivotValueComponent {...props} />
                    </div>
                  ))
                const ResolvedPivotComponent =
                  column.Pivot || DefaultResolvedPivotComponent

                // Is this cell expandable?
                if (cellInfo.pivoted || cellInfo.expander) {
                  // Make it expandable by defualt
                  cellInfo.expandable = true
                  useOnExpanderClick = true
                  // If pivoted, has no subRows, and does not have a subComponent, do not make expandable
                  if (cellInfo.pivoted && !cellInfo.subRows && !SubComponent) {
                    cellInfo.expandable = false
                  }
                }

                if (cellInfo.pivoted) {
                  // Is this column a branch?
                  isBranch =
                    rowInfo.row[pivotIDKey] === column.id && cellInfo.subRows
                  // Should this column be blank?
                  isPreview =
                    pivotBy.indexOf(column.id) >
                    pivotBy.indexOf(rowInfo.row[pivotIDKey]) && cellInfo.subRows
                  // Pivot Cell Render Override
                  if (isBranch) {
                    // isPivot
                    resolvedCell = _.normalizeComponent(
                      ResolvedPivotComponent,
                      {
                        ...cellInfo,
                        value: row[pivotValKey],
                      },
                      row[pivotValKey]
                    )
                  } else if (isPreview) {
                    // Show the pivot preview
                    resolvedCell = _.normalizeComponent(
                      ResolvedAggregatedComponent,
                      cellInfo,
                      value
                    )
                  } else {
                    resolvedCell = null
                  }
                } else if (cellInfo.aggregated) {
                  resolvedCell = _.normalizeComponent(
                    ResolvedAggregatedComponent,
                    cellInfo,
                    value
                  )
                }

                if (cellInfo.expander) {
                  resolvedCell = _.normalizeComponent(
                    ResolvedExpanderComponent,
                    cellInfo,
                    row[pivotValKey]
                  )
                  if (pivotBy) {
                    if (cellInfo.groupedByPivot) {
                      resolvedCell = null
                    }
                    if (!cellInfo.subRows && !SubComponent) {
                      resolvedCell = null
                    }
                  }
                }

                const resolvedOnExpanderClick = useOnExpanderClick
                  ? onExpanderClick
                  : () => { }

                // If there are multiple onClick events, make sure they don't override eachother. This should maybe be expanded to handle all function attributes
                const interactionProps = {
                  onClick: resolvedOnExpanderClick,
                }

                if (tdProps.rest.onClick) {
                  interactionProps.onClick = e => {
                    tdProps.rest.onClick(e, () => resolvedOnExpanderClick(e))
                  }
                }

                if (columnProps.rest.onClick) {
                  interactionProps.onClick = e => {
                    columnProps.rest.onClick(e, () => resolvedOnExpanderClick(e))
                  }
                }
                let isLinkTr = '';

                if (this.props.rowLink) {
                  isLinkTr = 'haslink'
                }

                if (this.props.noLink) {
                  isLinkTr = 'noLink'
                }

                // Return the cell
                // if(column.id === 'arrow'){
                //    TdRow =  <TdComponent onKeyDown={(event)=>this.expandableHanderOnEnter(rowInfo.index, event)} tabIndex="0" key={i2 + '-' + column.id}   className={classnames( classes, !show && 'hidden', cellInfo.expandable && 'rt-expandable',(isBranch || isPreview) && 'rt-pivot'   )} style={{...styles,flex: `${width} 0 auto`,width: _.asPx(width),  maxWidth: _.asPx(maxWidth),}} {...tdProps.rest}{...columnProps.rest} {...interactionProps}><i className={iconClass} onClick = {(event)=>this.expandableHander(rowInfo.index, event)}></i></TdComponent>
                // }else if(column.id === 'action'){
                //   TdRow = <TdComponent tabIndex="0" key={i2 + '-' + column.id}   className={classnames( classes,isLinkTr, !show && 'hidden', cellInfo.expandable && 'rt-expandable',(isBranch || isPreview) && 'rt-pivot'   )} style={{...styles,flex: `${width} 0 auto`,width: _.asPx(width),  maxWidth: _.asPx(maxWidth),}} {...tdProps.rest}{...columnProps.rest} {...interactionProps} onClick={()=>this.rowLink(rowInfo.original)}><i className={iconClassStatus}></i></TdComponent>
                // }else {
                //   TdRow = <TdComponent tabIndex="0" key={i2 + '-' + column.id}   className={classnames( classes,isLinkTr, !show && 'hidden', cellInfo.expandable && 'rt-expandable',(isBranch || isPreview) && 'rt-pivot'   )} style={{...styles,flex: `${width} 0 auto`,width: _.asPx(width),  maxWidth: _.asPx(maxWidth),}} {...tdProps.rest}{...columnProps.rest} {...interactionProps} onClick={()=>this.rowLink(rowInfo.original)}><span>{resolvedCell}</span></TdComponent>
                // }

                if (column.id === 'deleteUser') {
                  TdRow = <TdComponent
                    key={i2 + '-' + column.id} className={classnames(classes, !show && 'hidden', cellInfo.expandable && 'rt-expandable', (isBranch || isPreview) && 'rt-pivot')}
                    style={{ ...styles, flex: `${width} 0 auto`, width: _.asPx(width), maxWidth: _.asPx(maxWidth), }} {...tdProps.rest}{...columnProps.rest} {...interactionProps}
                  >
                    <i className="icon icon-bin delete-user" style={{ cursor: 'pointer' }} onClick={() => this.userLink(rowInfo.original)}></i>
                  </TdComponent>
                } else if (column.id === 'checkbox') {
                  TdRow = <TdComponent
                    key={i2 + '-' + column.id}
                    className={classnames(classes, isLinkTr, !show && 'hidden', cellInfo.expandable && 'rt-expandable', (isBranch || isPreview) && 'rt-pivot')}
                    style={{ ...styles, flex: `${width} 0 auto`, width: '3.125rem', maxWidth: '3.125rem', }} {...tdProps.rest}{...columnProps.rest} {...interactionProps}
                    onClick={() => this.checkGroup(rowInfo.original)}
                  >
                    <Checkbox
                      name={'checkbox' + i}
                      id={i + '-' + column.id}
                      onChange={(event) => this.selectedGroup(event, rowInfo.original)}
                      checked={this.isChecked(rowInfo.original.id)}
                      controlled
                    />
                  </TdComponent>
                } else if (column.id === 'revokeEntity') {
                  TdRow = <TdComponent
                    key={i2 + '-' + column.id}
                    className={classnames(classes, isLinkTr, !show && 'hidden', cellInfo.expandable && 'rt-expandable', (isBranch || isPreview) && 'rt-pivot')}
                    style={{ ...styles, flex: `${width} 0 auto`, width: _.asPx(width), maxWidth: _.asPx(maxWidth), }}
                    {...tdProps.rest}
                    {...columnProps.rest}
                    {...interactionProps}
                  >
                    <i className="icon icon-bin delete-user" style={{ cursor: 'pointer' }} onClick={() => this.userLink(rowInfo.original)}></i>
                  </TdComponent>
                } else {

                  TdRow = <TdComponent
                    tabIndex="0"
                    key={i2 + '-' + column.id}
                    className={classnames(classes, isLinkTr, !show && 'hidden', cellInfo.expandable && 'rt-expandable', (isBranch || isPreview) && 'rt-pivot')}
                    style={{ ...styles, flex: `${width} 0 auto`, width: _.asPx(width), maxWidth: _.asPx(maxWidth), }}
                    {...tdProps.rest}
                    {...columnProps.rest}
                    {...interactionProps}
                    onClick={() => this.rowLink(rowInfo.original)}
                  >
                    <span>{resolvedCell}</span>
                    <span>{column.id === 'entities' && resolvedCellRelated}</span>
                    <span>{column.id === 'productDatas' && resolvedProductCount}</span>
                  </TdComponent>
                }
                return (TdRow);
              })}
          </TrComponent>

          {rowInfo.subRows &&
            isExpanded &&
            rowInfo.subRows.map((d, i) =>
              makePageRow(d, i, rowInfo.nestingPath)
            )}
          {SubComponent &&
            !rowInfo.subRows &&
            isExpanded &&
            SubComponent(rowInfo)}
        </TrGroupComponent>
      )
    }

    /*const makePadRow = (row, i) => {
      const trGroupProps = getTrGroupProps(
        finalState,
        undefined,
        undefined,
        this
      )
      const trProps = _.splitProps(
        getTrProps(finalState, undefined, undefined, this)
      )
      return (
        <TrGroupComponent key={i} {...trGroupProps}>
          <TrComponent
            className={classnames(
              '-padRow',
              (pageRows.length + i) % 2 ? '-even' : '-odd',
              trProps.className
            )}
            style={trProps.style || {}}
          >
            {allVisibleColumns.map(makePadColumn)}
          </TrComponent>
        </TrGroupComponent>
      )
    } */

    /*const makePadColumn = (column, i) => {
      const resizedCol = resized.find(x => x.id === column.id) || {}
      const show =
        typeof column.show === 'function' ? column.show() : column.show
      let width = _.getFirstDefined(
        resizedCol.value,
        column.width,
        column.minWidth
      )
      let flex = width
      let maxWidth = _.getFirstDefined(
        resizedCol.value,
        column.width,
        column.maxWidth
      )
      const tdProps = _.splitProps(
        getTdProps(finalState, undefined, column, this)
      )
      const columnProps = _.splitProps(
        column.getProps(finalState, undefined, column, this)
      )
      const classes = [
        tdProps.className,
        column.className,
        columnProps.className,
      ]
      const styles = {
        ...tdProps.style,
        ...column.style,
        ...columnProps.style,
      }
      return (
        <TdComponent
          key={i + '-' + column.id}
          className={classnames(classes, !show && 'hidden')}
          style={{
            ...styles,
            flex: `${flex} 0 auto`,
            width: _.asPx(width),
            maxWidth: _.asPx(maxWidth),
          }}
          {...tdProps.rest}
        >
          {_.normalizeComponent(PadRowComponent)}
        </TdComponent>
      )
    } */

    const makeColumnFooters = () => {
      const tFootProps = getTfootProps(finalState, undefined, undefined, this)
      const tFootTrProps = _.splitProps(
        getTfootTrProps(finalState, undefined, undefined, this)
      )
      return (
        <TfootComponent
          className={tFootProps.className}
          style={{
            ...tFootProps.style,
            minWidth: `${rowMinWidth}px`,
          }}
          {...tFootProps.rest}
        >
          <TrComponent
            className={classnames(tFootTrProps.className)}
            style={tFootTrProps.style}
            {...tFootTrProps.rest}
          >
            {allVisibleColumns.map(makeColumnFooter)}
          </TrComponent>
        </TfootComponent>
      )
    }

    const makeColumnFooter = (column, i) => {
      const resizedCol = resized.find(x => x.id === column.id) || {}
      const show =
        typeof column.show === 'function' ? column.show() : column.show
      const width = _.getFirstDefined(
        resizedCol.value,
        column.width,
        column.minWidth
      )
      const maxWidth = _.getFirstDefined(
        resizedCol.value,
        column.width,
        column.maxWidth
      )
      const tFootTdProps = _.splitProps(
        getTfootTdProps(finalState, undefined, undefined, this)
      )
      const columnProps = _.splitProps(
        column.getProps(finalState, undefined, column, this)
      )
      const columnFooterProps = _.splitProps(
        column.getFooterProps(finalState, undefined, column, this)
      )

      const classes = [
        tFootTdProps.className,
        column.className,
        columnProps.className,
        columnFooterProps.className,
      ]

      const styles = {
        ...tFootTdProps.style,
        ...column.style,
        ...columnProps.style,
        ...columnFooterProps.style,
      }

      return (
        <TdComponent
          key={i + '-' + column.id}
          className={classnames(classes, !show && 'hidden')}
          style={{
            ...styles,
            flex: `${width} 0 auto`,
            width: _.asPx(width),
            maxWidth: _.asPx(maxWidth),
          }}
          {...columnProps.rest}
          {...tFootTdProps.rest}
          {...columnFooterProps.rest}
        >
          {_.normalizeComponent(column.Footer, {
            data: sortedData,
            column: column,
          })}
        </TdComponent>
      )
    }

    const makePagination = () => {
      const paginationProps = _.splitProps(
        getPaginationProps(finalState, undefined, undefined, this)
      )
      return (
        <PaginationComponent
          {...resolvedState}
          pages={pages}
          canPrevious={canPrevious}
          pageJson={this.props.pageJsonContent}
          canNext={canNext}
          onPageChange={this.onPageChange}
          onPageSizeChange={this.onPageSizeChange}
          className={paginationProps.className}
          style={paginationProps.style}
          {...paginationProps.rest}
          lang={this.props.lang}
        />
      )
    }

    const rootProps = _.splitProps(
      getProps(finalState, undefined, undefined, this)
    )
    const tableProps = _.splitProps(
      getTableProps(finalState, undefined, undefined, this)
    )
    const tBodyProps = _.splitProps(
      getTbodyProps(finalState, undefined, undefined, this)
    )
    const loadingProps = getLoadingProps(finalState, undefined, undefined, this)
    const noDataProps = getNoDataProps(finalState, undefined, undefined, this)
    const resizerProps = getResizerProps(finalState, undefined, undefined, this)

    const makeTable = () => {
      const pagination = makePagination()
      return (
        <div
          className={classnames('GdocReactTable', className, rootProps.className)}
          style={{
            ...style,
            ...rootProps.style,
          }}
          {...rootProps.rest}
        >
          {showPagination && showPaginationTop
            ? <div className='pagination-top'>
              {pagination}
            </div>
            : null}
          <TableComponent
            className={classnames(
              tableProps.className,
              currentlyResizing ? 'rt-resizing' : ''
            )}
            style={tableProps.style}
            {...tableProps.rest}
          >
            {hasHeaderGroups ? makeHeaderGroups() : null}
            {makeHeaders()}
            {hasFilters ? makeFilters() : null}
            <TbodyComponent
              className={classnames(tBodyProps.className)}
              style={{
                ...tBodyProps.style,
                minWidth: `${rowMinWidth}px`,
              }}
              {...tBodyProps.rest}
            >
              {pageRows.map((d, i) => makePageRow(d, i))}
              { /*padRows.map(makePadRow) */}
            </TbodyComponent>
            {hasColumnFooter ? makeColumnFooters() : null}
          </TableComponent>
          {showPagination && showPaginationBottom
            ? <div className='pagination-bottom'>
              {pagination}
            </div>
            : null}
          {!pageRows.length &&
            <NoDataComponent {...noDataProps}>
              {_.normalizeComponent(noDataText)}
            </NoDataComponent>}
          <LoadingComponent
            loading={loading}
            loadingText={loadingText}
            {...loadingProps}
          />
        </div>
      )
    }

    // childProps are optionally passed to a function-as-a-child
    return children ? children(finalState, makeTable, this) : makeTable()
  }

}


// WEBPACK FOOTER //
// ./src/components/Admin/AdminPanel/SubComp/Grid/Table/index.js